export default "__VITE_ASSET__BoiG9h76__"